import { useMedia } from "react-media";

export function useBreakpoint() {
  // Breakpoint values match the configured tailwind breakpoints
  const xxs = useMedia({ query: "(max-width: 320px)" });
  const xs = useMedia({ query: "(max-width: 480px)" });
  const sm = useMedia({ query: "(max-width: 640px)" });
  const md = useMedia({ query: "(max-width: 768px)" });
  const lg = useMedia({ query: "(max-width: 1024px)" });
  const xl = useMedia({ query: "(max-width: 1280px)" });
  const xxl = useMedia({ query: "(max-width: 1536px)" });

  return {
    xxs,
    xs,
    sm,
    md,
    lg,
    xl,
    xxl,
  };
}
